import {
  getAuthData,
  isAuthRestricted,
  makeFakeAuthState,
} from 'app/auth/Selectors';

import { RequiredBehaviors } from 'app/beta-editor/pages/types';
import isValidAuth from 'app/beta-editor/utils/isValidAuth';
import serviceNeedsAuth from 'app/beta-editor/utils/serviceNeedsAuth';

const authBehavior: RequiredBehaviors = {
  label() {
    return 'Choose Account';
  },

  menuLabel() {
    return authBehavior.label();
  },

  crumbLabel() {
    return authBehavior.label();
  },

  data(props) {
    const { node, services, auths, isZapTemplate } = props;
    const authId = node.authentication_id;
    const isRestrictedAccount = isAuthRestricted(
      authId,
      makeFakeAuthState(auths)
    );

    if (!authId || !isValidAuth(node, services)) {
      return isZapTemplate ? 'Use Sample Data' : undefined;
    }

    if (isRestrictedAccount) {
      return 'Restricted Account';
    }

    const auth = getAuthData(authId, makeFakeAuthState(auths));
    return (auth || {}).title ? auth.title : 'Account';
  },

  status({ node, services }) {
    return isValidAuth(node, services) ? 'success' : '';
  },

  visible({ node, services }) {
    const needsAuth = serviceNeedsAuth(node, services);
    return Boolean(node.selected_api && node.action && needsAuth);
  },

  isClickable() {
    return true;
  },

  isLocked() {
    return false;
  },
};

export default authBehavior;
